import { render, staticRenderFns } from "./ProjectPlatform.vue?vue&type=template&id=67ce3951"
import script from "./ProjectPlatform.vue?vue&type=script&lang=js"
export * from "./ProjectPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports